import { Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const CallFinishedAccount = () => {
  const navigate = useNavigate()

  return (
    <div className='flex flex-col justify-center items-center gap-4 fixed top-0 left-0 w-[100vw] h-[100vh] z-[1000] bg-white'>
      <p>Su llamada ha finalizado</p>
      <Button onClick={() => navigate('/accounts')}>Volver al Inicio</Button>
    </div>
  )
}

export default CallFinishedAccount
